import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket/store'
import { type IResponseEventUserPermissions } from 'entities/UsersPermissions/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'

export const useEventUserPermissionsUpdated = () => {
  const { websocket, userPermissionsStore } = useEntitiesContext()

  const callback = (data: IResponseEventUserPermissions) => {
    userPermissionsStore.updatePermissions(data.permissions)
  }

  useEffect(() => websocket.on(WebsocketEvent.PermissionsUpdated, callback), [])
}
